export const environment = {
	production: false,
	apiUrl: 'https://sat-uatbau.allianz.com.my/sat-motor-svc/v1',
	commonSvcUrl: 'https://sat-uatbau.allianz.com.my/sat-common-svc/api/v1',
	authRefreshBufferMs: 30000,
	alpha_url: 'https://alpha-test.allianz.com.my/alpha-web/autoLogin.zul?token=',
	googleApiKey: 'googleApiKey',
	googleMapId:'googleMapId'
};
